export default {
  XRT: "0x7dE91B204C1C737bcEe6F000AAA6569Cf7061cb7",
  VOTE: "0xbc4Bcd65BFE63D29d2463FC21f0d3a6206e301CD",
  MINTER: "0x3F127034cA0427F77FE94bd07ffBBc7a2b5b1C3D"
};
